import { TILE_SIZES } from '@mixtiles/web-backend-shared'

import { ProductRouteType } from './productPages/types'
import { LANGUAGES, SUPPORTED_LANGUAGES } from '../../locale/Translation.consts'

export const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH
export const DEFAULT_COUNTRY = 'US'
export const DEFAULT_LOCALE = `${DEFAULT_LANGUAGE}-${DEFAULT_COUNTRY}`

export const LATAM_COUNTRIES = [
  'MX',
  'GT',
  'HN',
  'SV',
  'NI',
  'CR',
  'PA',
  'CU',
  'DO',
  'CO',
  'VE',
  'EC',
  'PE',
  'BO',
  'CL',
  'AR',
  'UY',
  'PY',
  'PR',
] as const

export const DEFAULT_SITE_TITLE =
  'Mixtiles - Turn your photos into affordable, stunning wall art'

export const DEFAULT_SITE_DESCRIPTION =
  "Mixtiles are printed framed pictures that stick to any wall, leave no damage, and can be moved around. The entire experience is super easy - pick your best pics, choose frames, select the style you like, we ship them free right to your door, you stick them to your wall. It's that easy!"

export const SUPPORTED_COUNTRIES = {
  [LANGUAGES.ENGLISH]: ['US', 'CA', 'GB', 'AU', 'IE'],
  [LANGUAGES.SPANISH]: ['ES', 'US', ...LATAM_COUNTRIES],
  [LANGUAGES.FRENCH]: ['FR', 'CA', 'BE'],
  [LANGUAGES.GERMAN]: ['DE', 'AT'],
  [LANGUAGES.JAPANESE]: ['JP'],
} as const

export const SUPPORTED_LOCALES = SUPPORTED_LANGUAGES.flatMap((language) =>
  SUPPORTED_COUNTRIES[language].map((country) => `${language}-${country}`)
)

export const URL_PARAMS = {
  SIZE: 'size',
  MATERIAL: 'material',
  LANGUAGE: 'language',
  FORCE_COUNTRY: 'forceCountry',
  SKU: 'sku',
} as const

export const TRANSFORMATION_PARAMS = [
  URL_PARAMS.SIZE,
  URL_PARAMS.MATERIAL,
  URL_PARAMS.LANGUAGE,
  URL_PARAMS.FORCE_COUNTRY,
] as const

export const INDEXED_TILE_SIZES: Partial<
  Record<ProductRouteType, readonly TILE_SIZES[]>
> = {
  [ProductRouteType.CANVAS]: [
    TILE_SIZES.SQUARE_8X8,
    TILE_SIZES.SQUARE_12X12,
    TILE_SIZES.RECTANGLE_16X12,
    TILE_SIZES.SQUARE_20X20,
  ],
  [ProductRouteType.PHOTOTILES]: [
    TILE_SIZES.SQUARE_8X8,
    TILE_SIZES.SQUARE_12X12,
    TILE_SIZES.SQUARE_20X20,
  ],
  [ProductRouteType.ART]: [],
} as const
